import { instance } from 'api/api';
import { APIResponse } from 'tools/types';
import { RawIssuesContext } from 'api/element-issues';

export const datasetIssuesAPI = {
    async getContext(datasetId: number): Promise<RawIssuesContext> {
        const response = await instance.get<APIResponse<RawIssuesContext>>(`data/editor/dataset/${datasetId}/issues`);
        return response.data.data;
    },

    async answerQuestion(datasetId: number, questionId: string, answer: string): Promise<void> {
        await instance.post(`data/editor/dataset/${datasetId}/clarifying-question/${questionId}/answer`, { answer });
    },

    async skipQuestion(datasetId: number, questionId: string): Promise<void> {
        await instance.post(`data/editor/dataset/${datasetId}/clarifying-question/${questionId}/skip`);
    },

    async undoQuestion(datasetId: number, questionId: string): Promise<void> {
        await instance.post(`data/editor/dataset/${datasetId}/clarifying-question/${questionId}/undo`);
    },
};
